/*=========================================================================================
  File Name: bookingform.js
  Description: Main booking form file
  ----------------------------------------------------------------------------------------
  Item Name: Convertlabs - Client Booking Form
  Version: 1.0
  Author: Nerdpilots
  Author URL: http://convertlabs.io
==========================================================================================*/

import Vue from 'vue'

import 'flex.box/src/flexbox.css'




import VueI18n from 'vue-i18n'
import GmapVue from 'gmap-vue'

Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key:  import.meta.env.VITE_GMAPS_KEY,
    // [OPTIONAL] This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    libraries: 'places',

    // This option was added on v3.0.0 but will be removed in the next major release.
    // If you already have an script tag that loads Google Maps API and you want to use it set you callback
    // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
    // to the `window` object, is the only requirement.
  //   customCallback: 'MyCustomCallback',
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,

  // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
  dynamicLoad: false,
})
Vue.use(VueI18n)


// Accessing query parameters without Vue Router
const queryParams = new URLSearchParams(window.location.search);

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import './assets/index.css';
Vue.use(ElementUI, { locale })

import axios from 'axios'

Vue.prototype.$http = axios;
Vue.prototype.axios = axios;

import {pricings} from './pricings'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
    moment,
})

Vue.config.productionTip = false
axios.defaults.baseURL = `/api`

const type = queryParams.get('type');
let messageType;

switch (type) {
    case 'handyman':
        messageType = 'messagesHandyman';
        break;
    case 'autodetail':
        messageType = 'messagesAutoDetail';
        break;
    case 'autotint':
        messageType = 'messagesAutoTint';
        break;
    case 'lawncare':
        messageType = 'messagesLawnCare';
        break;
    // Add more cases as needed
    default:
        messageType = 'messages';
}

import(`./i8n/${messageType}.js`).then((mod) => {
    new Vue({
        el: '#app',
        i18n: new VueI18n({
            locale: queryParams.get('lang'),
            fallbackLocale: 'en',
            messages: mod.default
        }),
        mixins: [pricings],
        components: {
            BookingForm : () => import(/* webpackChunkName: "bookingForm" */ './BookingForm.vue'),
            BookingFormNew : () => import(/* webpackChunkName: "bookingForm" */ './BookingFormNew.vue'),
            BookingFormStepper : () => import(/* webpackChunkName: "bookingForm" */ './BookingFormStepper.vue'),

        }
    })
});

